import { render, staticRenderFns } from "./goTop.vue?vue&type=template&id=fb01897e&scoped=true"
import script from "./goTop.vue?vue&type=script&lang=js"
export * from "./goTop.vue?vue&type=script&lang=js"
import style0 from "./goTop.vue?vue&type=style&index=0&id=fb01897e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb01897e",
  null
  
)

export default component.exports